import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { useReviewContext } from '../../../Context';
type ReviewProductCardApplyNowTitleProps = {
  thinTitle?: boolean;
};
export default function ReviewProductCardTitle(t0) {
  const $ = _c(4);
  const {
    thinTitle: t1
  } = t0;
  const thinTitle = t1 === undefined ? false : t1;
  const {
    marketplaceEntity: t2
  } = useReviewContext();
  const {
    displayName
  } = t2;
  const t3 = thinTitle ? "text" : "textBold";
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: "1.25rem"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== displayName || $[2] !== t3) {
    t5 = <Typography variant={t3} sx={t4} data-testid="stickySideBarCardName">{displayName}</Typography>;
    $[1] = displayName;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}